import { useEffect, useState } from 'react';

const SESSION_KEY = 'dismissed_promotion';
const listeners = new Set<() => void>();

function notify() {
  for (const fn of listeners) {
    fn();
  }
}

export function useDismissedPromotion() {
  const [dismissedId, setDismissedId] = useState(() => sessionStorage.getItem(SESSION_KEY));

  useEffect(() => {
    const sync = () => {
      setDismissedId(sessionStorage.getItem(SESSION_KEY));
    };
    listeners.add(sync);
    return () => {
      listeners.delete(sync);
    };
  }, []);

  const dismiss = (id: string) => {
    sessionStorage.setItem(SESSION_KEY, id);
    setDismissedId(id);
    notify();
  };

  const clearDismiss = () => {
    sessionStorage.removeItem(SESSION_KEY);
    setDismissedId(null);
    notify();
  };

  return { dismissedId, dismiss, clearDismiss };
}
